import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AutoComplete from 'material-ui/AutoComplete';
import getTheme from '../MuiTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';

var LLAutoCompleteField = /*#__PURE__*/function (_Component) {
  _inherits(LLAutoCompleteField, _Component);

  var _super = _createSuper(LLAutoCompleteField);

  function LLAutoCompleteField() {
    var _this;

    _classCallCheck(this, LLAutoCompleteField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "convertInterestsData", function (dataSource) {
      return dataSource.map(function (d, index) {
        return {
          text: d.name,
          value: d.id,
          index: index
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleInterestsNewRequest", function (val) {
      if (_this.props.searchType === 'interests') {
        val = _this.props.dataSource[val.index];
      }

      _this.props.onNewRequest(val);
    });

    return _this;
  }

  _createClass(LLAutoCompleteField, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var data = this.props.searchType === 'interests' ? this.convertInterestsData(this.props.dataSource) : this.props.dataSource;
      return /*#__PURE__*/React.createElement(AutoComplete, _extends({}, this.props, {
        dataSource: data,
        onUpdateInput: function onUpdateInput(val) {
          if (_this2.props.onUpdateInput) {
            _this2.props.onUpdateInput(val);
          }

          _this2.props.onChange(val);
        },
        onNewRequest: this.handleInterestsNewRequest
      }));
    }
  }]);

  return LLAutoCompleteField;
}(Component);

_defineProperty(LLAutoCompleteField, "propTypes", {
  placeholder: PropTypes.string,
  style: PropTypes.object,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  dataSource: PropTypes.array.isRequired,
  onNewRequest: PropTypes.func,
  onUpdateInput: PropTypes.func,
  searchText: PropTypes.string
});

_defineProperty(LLAutoCompleteField, "defaultProps", {
  placeholder: '',
  style: {},
  value: '',
  onChange: null,
  dataSource: [],
  onNewRequest: null,
  onUpdateInput: null,
  searchText: '',
  searchType: 'other'
});

export { LLAutoCompleteField as default };